import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { CacheService } from '../services';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private _cacheService: CacheService = inject(CacheService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.method !== 'GET') {
      this._cacheService.invalidateCache();
      return next.handle(req);
    }

    const cached = this._cacheService.retrieve(req.url);
    if (cached) {
      return of(cached);
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this._cacheService.store(req.urlWithParams, event);
        }
      })
    );
  }
}
